import { render } from "./SignerRoom.vue?vue&type=template&id=a3a709fa&scoped=true"
import script from "./SignerRoom.vue?vue&type=script&lang=js"
export * from "./SignerRoom.vue?vue&type=script&lang=js"

import "./SignerRoom.vue?vue&type=style&index=0&id=a3a709fa&scoped=true&lang=css"
import "./SignerRoom.vue?vue&type=style&index=1&id=a3a709fa&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3a709fa"]])

export default __exports__